.skeletonWrapper {
  flex-grow: 1;
  padding: 16px;
}
